// extracted by mini-css-extract-plugin
module.exports = {"formLabel":"FormLabel_formLabel_23Xne","small":"FormLabel_small_1kFu6"};
    if(module.hot) {
      // 1789136763078
      var cssReload = require("/drone/src/node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":true});
      module.hot.dispose(cssReload);
      
    }
  